import { memo, useCallback } from 'react'

import { useQuery } from '@tanstack/react-query'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { Header } from '@shared/components/Header'
import { Tabs } from '@shared/components/MaterialUIEnhancements/Tabs'
import { Content } from '@shared/layouts'
import { NavigationTabLink } from 'components/LinkedMUIComponents/NavigationTabLink'
import { ActionsMenu } from 'domains/MediaLibraries/MediaLibrary/ActionsMenu'
import { useMediaLibraryUpdateMutation } from 'hooks/mutations/publishing'
import { mediaLibraryRoute } from 'pages/NWPlatform/MediaLibraries/MediaLibrary/Routing'
import { mediaLibraryQueryKeys } from 'services/queryKeys'

const StructureRaw = () => {
  const { t } = useTranslation(['common', 'pages', 'entity'])
  const { enqueueSnackbar } = useSnackbar()

  const { mediaLibraryId } = mediaLibraryRoute.useParams()

  const mediaLibraryQuery = useQuery(mediaLibraryQueryKeys.detail({ libraryId: mediaLibraryId }))
  const { data: mediaLibrary } = mediaLibraryQuery

  const { mutate: updateMediaLibrary, ...mediaLibraryUpdateMutation } = useMediaLibraryUpdateMutation()

  const handleUpdateMediaLibraryName = useCallback(
    (title: string, closeCallback: () => void) => {
      if (mediaLibrary) {
        updateMediaLibrary(
          {
            libraryId: mediaLibraryId,
            mediaPlatformEdit: {
              name: title,
            },
          },
          {
            onError: () => enqueueSnackbar(t('pages:MediaLibrary.updateError')),
            onSettled: closeCallback,
          },
        )
      }
    },
    [t, mediaLibrary, updateMediaLibrary, mediaLibraryId, enqueueSnackbar],
  )

  return (
    <Content
      HeaderSlot={
        <Header
          title={mediaLibraryQuery.data?.name ?? ''}
          isLoading={mediaLibraryQuery.isLoading}
          isSaving={mediaLibraryUpdateMutation.isPending}
          onSave={handleUpdateMediaLibraryName}
          TabNavigation={
            <Tabs>
              <NavigationTabLink
                from={mediaLibraryRoute.fullPath}
                to="/organizations/$organizationId/environments/$environmentId/media-libraries/$mediaLibraryId/config"
              >
                {t('common:config')}
              </NavigationTabLink>
              <NavigationTabLink
                from={mediaLibraryRoute.fullPath}
                to="/organizations/$organizationId/environments/$environmentId/media-libraries/$mediaLibraryId/entries"
              >
                {t('pages:MediaOTT.mediaLibrary.entries')}
              </NavigationTabLink>
              {/* <NavigationTabLink
                from={mediaLibraryRoute.fullPath}
                to="/organizations/$organizationId/environments/$environmentId/media-libraries/$mediaLibraryId/channels"
              >
                {t('pages:MediaOTT.mediaLibrary.channels')}
              </NavigationTabLink> */}
            </Tabs>
          }
          Actions={<ActionsMenu />}
        />
      }
    />
  )
}

export const Structure = memo(StructureRaw)
